import React from 'react';
import { FiSearch, FiChevronRight } from "react-icons/fi";

export const SelectTest = ({ searchValue, onSearchChange }) => (
    <div className="w-full">
        {/* Banner Bar */}
        <div className="w-full bg-[#88C0FF] h-[74px] rounded-[5px] flex items-center justify-center mb-8 shadow-sm">
            <span className="text-[#3333333] font-inter text-[28px] font-[500] tracking-[-2px]">
                Select Your Test
            </span>
        </div>
        {/* Search Bar */}
        <div className="flex justify-end mb-8">
            <div className="relative w-full max-w-[475px]">
                <input
                    type="text"
                    placeholder="Search for Courses, test, or Study Material..."
                    value={searchValue}
                    onChange={onSearchChange}
                    className="w-full h-[40px] pl-4 pr-10 rounded-[5px] border border-[#33333399] outline-none text-[#3333333] placeholder:text-[#33333399] text-[16px] font-[500] font-inter tracking-tight"
                />
                <FiSearch className="absolute right-3 top-1/2 -translate-y-1/2 text-[#333333B2] text-[18px]" />
            </div>
        </div>
    </div>
);

export const PracticeCard = ({ exam, onClick }) => {
    if (!exam) return null;

    return (
        <div
            onClick={() => onClick(exam)}
            className="bg-[#88C0FF] w-full rounded-[10px] py-[10px] md:py-[20px] px-[10px] md:px-[16px] flex items-center justify-between hover:brightness-95 transition-all cursor-pointer group"
        >
            <div className="flex items-center gap-3 overflow-hidden">
                <div className="w-[39px] h-[39px] flex items-center justify-center rounded-full shrink-0 shadow-sm">
                    <img 
                        src={exam.icon} 
                        alt={exam.name} 
                        className="w-full h-full object-contain" 
                    />
                </div>
                <div className="flex flex-col leading-tight overflow-hidden text-left">
                    <span className="text-[14px] md:text-[16px] font-[500] text-[#3333333] tracking-tight whitespace-nowrap">
                        {exam.name}
                    </span>
                    <span className="text-[14px] md:text-[16px] font-[500] text-[#33333399] font-inter tracking-tight">
                        {exam.papers}
                    </span>
                </div>
            </div>
            <div className="shrink-0 pl-2">
                <FiChevronRight 
                    size={20} 
                    className="text-[#333333] group-hover:translate-x-1 transition-transform" 
                />
            </div>
        </div>
    );
};